const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition || window.mozSpeechRecognition;
const SpeechGrammarList = window.SpeechGrammarList || window.webkitSpeechGrammarList || window.mozSpeechGrammarList;

PF.Speech = class Speech extends PF.Entity
	{

	static get options()
		{
		return {
			// grammars: '',
			startOnInit: true
		};
		}

	init()
		{
		this.recognition = new SpeechRecognition();
		this.recognition.lang = "ru-RU";
		if (!this.isMobile())
			{
			this.recognition.continuous = true;
			this.recognition.interimResults = true;
			}

		// var speechRecognitionList = new SpeechGrammarList();
		// speechRecognitionList.addFromString(this.grammars, 1);

		this.recognition.maxAlternatives = 1;
		this.isRecognizing = false;
		this.transcript = "";
		if (this.startOnInit === true)
			{
			// this.start();
			}
		}

	isMobile()
		{
		return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
		}

	start()
		{
		this.transcript = "";
		this.recognition.onresult = (event) => this.onResult(event);
		this.recognition.start();
		this.isRecognizing = true;
		console.log("Started recognition");
		}

	stop()
		{
		this.recognition.abort();
		this.isRecognizing = false;
		console.log("Stopped recognition");
		}

	onResult(event)
		{
		var interim_transcript = "";
		console.log(event);
		for (var i = event.resultIndex; i < event.results.length; ++i)
			{
			var result = event.results[i];
			if (result.isFinal)
				{
				this.trigger('final', result[0].transcript);
				// this.transcript += result[0].transcript;
				}
			else
				{
				this.trigger('interim', result[0].transcript);
				// interim_transcript += result[0].transcript;
				}
			}
		// console.log(interim_transcript);

		// this.trigger('result', interim_transcript);
		}


	};
